import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';
import { company, footerNote, homeImages, links } from '../data/siteData';

export default function Footer({ items }) {
  return (
    <footer className="footer">
      <div className="shell footer__grid">
        <div>
          <div className="brand brand--footer brand--with-logo">
            <img src={homeImages.symbol} alt="BrainTorch™ Bio torch symbol" className="brand__logo" />
            <span className="brand__text">
              <span className="brand__name">{company.name}</span>
              <span className="brand__eyebrow">{company.eyebrow}</span>
            </span>
          </div>
          <p className="footer__copy">{footerNote}</p>
        </div>

        <div>
          <h4 className="footer__heading">Quick Links</h4>
          <div className="footer__links">
            {items.map((item) => (
              <Link key={item.path} to={item.path}>
                {item.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <h4 className="footer__heading">Services</h4>
          <div className="footer__links">
            <Link to="/services/scientific-consulting">Scientific & Research Consulting</Link>
            <Link to="/services/stem-workforce">STEM Education & Workforce Development</Link>
            <Link to="/services/mentorship">Mentorship & Career Development</Link>
            <Link to="/impact">BrainTorch™ Launch</Link>
          </div>
        </div>

        <div>
          <h4 className="footer__heading">Stay Connected</h4>
          <div className="footer__links footer__links--stacked">
            <span>{company.phone}</span>
            <a href={`mailto:${company.email}`}><Mail size={15} /> {company.email}</a>
            {links.linkedin ? (
              <a href={links.linkedin} target="_blank" rel="noopener noreferrer"><Linkedin size={16} /> LinkedIn</a>
            ) : null}
            <span>{company.location}</span>
          </div>
        </div>
      </div>
      <div className="shell footer__bottom">© {new Date().getFullYear()} {company.name}. All rights reserved.</div>
    </footer>
  );
}
